import { render, staticRenderFns } from "./agent-authorization.vue?vue&type=template&id=c78c83ba&scoped=true"
import script from "./agent-authorization.vue?vue&type=script&lang=js"
export * from "./agent-authorization.vue?vue&type=script&lang=js"
import style0 from "./agent-authorization.vue?vue&type=style&index=0&id=c78c83ba&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c78c83ba",
  null
  
)

export default component.exports